import React, { useEffect } from 'react';

import { TeamOutlined } from '@ant-design/icons';
import { Badge, List, Typography } from 'antd';
import { generatePath } from 'react-router-dom';

import { MenuItemWrapper } from 'common-ui/leftMenu';
import { conversationsApi, selectWebSocketStatus, useAppSelector } from 'core/lib';
import colors from 'core/lib/theme/colors';
import { HubConnectionState } from 'core/lib/utils/signalR/utils';
import { Routes } from 'routes/routes';
import { useMatchParamId } from 'utils/hooks';
import { useHub } from 'utils/hooks/hubHooks';

import { CreateGroupConversationModal } from '../components';

const { Text } = Typography;

const GroupConversationsMenu = () => {
  const { data = [], isFetching } = conversationsApi.useGetMyMenuGroupConversationsQuery();
  const [hub] = useHub();
  const webSocketStatus = useAppSelector(selectWebSocketStatus);

  const routeConvId = useMatchParamId(Routes.CONVERSATIONS_GROUP_DETAILS.path);

  const isActive = (groupConversationId: number) => {
    return routeConvId && parseInt(routeConvId) === groupConversationId;
  };

  useEffect(() => {
    if (webSocketStatus === HubConnectionState.Connected) {
      hub.conversations.joinGroupConversationMenu();
    }
    return () => {
      hub.conversations.leaveGroupConversationMenu();
    };
  }, [hub.conversations, webSocketStatus]);

  return (
    <div className="flex flex-col gap-2">
      <List
        className="empty-list-no-image"
        locale={{ emptyText: <></> }}
        loading={isFetching}
        split={false}
        dataSource={data}
        renderItem={(conversation) => {
          return (
            <MenuItemWrapper
              isActive={!!isActive(conversation.id)}
              path={generatePath(Routes.CONVERSATIONS_GROUP_DETAILS.path, { id: conversation.id })}
              linkClassName="py-2"
              menuItemClassName="px-4"
            >
              <Text className="text-inherit gap-2" ellipsis>
                <TeamOutlined className="mr-2" />
                {conversation.title}
              </Text>
              <Badge
                count={conversation.undreadMessages}
                className="leading-auto"
                style={{ backgroundColor: colors.Primary.rgba }}
              />
            </MenuItemWrapper>
          );
        }}
      />
      <CreateGroupConversationModal />
    </div>
  );
};

export default GroupConversationsMenu;
